export default __webpack_public_path__ + "static/media/icon_trash.396364ff.svg";